// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"03b7cb47","354":"03b7cb47","536":"718902c3","552":"bd1fd209","854":"03b7cb47","911":"03b7cb47","963":"83c0ef97"}[chunkId] + ".chunk.css";
};